import React, { useEffect, useState, useMemo } from 'react'
import { App, Modal } from 'antd';
import { Listbox } from '../../../ui/forms/UIObjects';
import { Row, Col } from 'react-bootstrap';
import { UIText, UIButton } from '../../../ui/UIElements';
import { getDashboardFilter } from '../../../../pages/api/Employer/Employer';
import { useRouter } from 'next/router';
import { DynamicSkeleton } from '@/components/skeleton';
import { createUseStyles } from 'react-jss';

const FILTER_DEFAULTS = {
  jobId: 0,
  jobStatus: 1,
  companyCode: "0",
  rId: 0
}
const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
const DashboardFilterModal = ({ isModalOpen, setIsModalOpen, getData, setFinalData, finalData, getJobs }) => {
  const router = useRouter();
  const [jobTitle, setJobTitles] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [Stations, setStations] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onLoadLoading, setOnLoadLoading] = useState(false);
  const { message } = App.useApp();

  const mapOpts = (obj, all) => {
    const opts = Object.entries(obj || {}).map(([v, t]) => [v, t]);
    return all ? [all, ...opts] : opts;
  };


  const getFilterData = async (jobId = -1, jobStatus = -1, companyCode = -1) => {
    try {
      setLoading(true);
      const res = await getDashboardFilter(jobId, jobStatus, companyCode);
      if (res?.Status === 1) {
        const f = res.Filters;
        setJobTitles(mapOpts(f?.Jobs, ["", "All Jobs"]));
        setStations(mapOpts(f?.Stations, [0, "All Stations"]).map(([v, t]) => [Number(v), t]));
        setCompanies(mapOpts(f?.Companies, ["0", "All Companies"]));
        setJobStatus(mapOpts(f?.JobStatus).map(([v, t]) => [Number(v), t]));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(true);
      setIsModalOpen(false);
    }
  };

  const getFilterDataFirstLoad = async (jobId = -1, jobStatus = -1, companyCode = -1) => {
    try {
      setOnLoadLoading(true);
      const res = await getDashboardFilter(jobId, jobStatus, companyCode);
      if (res?.Status === 1) {
        const f = res.Filters;
        setJobTitles(mapOpts(f?.Jobs, ["", "All Jobs"]));
        setStations(mapOpts(f?.Stations, [0, "All Stations"]).map(([v, t]) => [Number(v), t]));
        setCompanies(mapOpts(f?.Companies, ["0", "All Companies"]));
        setJobStatus(mapOpts(f?.JobStatus).map(([v, t]) => [Number(v), t]));
        setOnLoadLoading(false);
      }
    } catch (error) {
      console.log(error);
      setOnLoadLoading(true);
      setIsModalOpen(false);
    }
  };

  const getFilterDataRecruiters = async (jobId = -1, jobStatus = -1, companyCode = -1) => {
    try {
      setLoading(true);
      const res = await getDashboardFilter(jobId, jobStatus, companyCode);
      if (res?.Status === 1) {
        const f = res.Filters;
        setRecruiters(mapOpts(f?.Recruiters, ["0", "All Recruiters"]).map(([v, t]) => [Number(v), t]));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(true);
      setIsModalOpen(false);
    }
  };


  const getFilterDataStatusChange = async (jobId = -1, jobStatus = -1, companyCode = -1) => {
    try {
      setLoading(true);
      const res = await getDashboardFilter(jobId, jobStatus, companyCode);
      if (res?.Status === 1) {
        const f = res.Filters;
        setJobTitles(mapOpts(f?.Jobs, ["", "All Jobs"]));
        setRecruiters(mapOpts([], ["0", "All Recruiters"]).map(([v, t]) => [Number(v), t]));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(true);
      setIsModalOpen(false);
    }
  };


  const getFilterDataJobChange = async (jobId = -1, jobStatus = -1, companyCode = -1) => {
    try {
      setLoading(true);
      const res = await getDashboardFilter(jobId, jobStatus, companyCode);
      if (res?.Status === 1) {
        const f = res.Filters;
        setRecruiters(mapOpts(f?.Recruiters, ["0", "All Recruiters"]).map(([v, t]) => [Number(v), t]));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(true);
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    if (!isModalOpen) return;
    getFilterDataFirstLoad(-1, finalData?.jobStatus, finalData?.companyCode);
    getFilterDataRecruiters(finalData.jobId, finalData?.jobStatus, finalData?.companyCode);
  }, [isModalOpen]);

  const safeValues = useMemo(() => {
    const f = finalData || {};
    return {
      js: typeof f.jobId === "string" ? f.jobId : "",
      jst: Number.isFinite(Number(f.jobStatus)) ? Number(f.jobStatus) : FILTER_DEFAULTS.jobStatus,
      cc: typeof f.companyCode === "string" ? f.companyCode : "0",
      rt: Number.isFinite(Number(f.rId)) ? Number(f.rId) : FILTER_DEFAULTS.rId
    };
  }, [finalData]);

  const ApplyFilters = () => {
    const payload = {
      jobId: safeValues.js || -1,
      jobStatus: safeValues.jst,
      companyCode: safeValues.cc || -1,
      rId: safeValues.rt || -1
    };
    getData(payload);
    getJobs(router.query, payload);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onChangeJobs = (val) => {
    setFinalData(prev => ({ ...(prev || {}), rId: 0, jobId: String(val) }))
    getFilterDataJobChange(val, safeValues.jst, safeValues.companyCode);
  };
  const onJobStatusChange = (val) => {
    setFinalData(prev => ({ ...(prev || {}), jobId: 0, jobStatus: toNum(val) }));
    if (val == -1) {
      getFilterData(-1, -1, safeValues.cc);
      getFilterDataRecruiters(-1, -1, safeValues.cc);
    } else {
      getFilterData(-1, val, safeValues.cc);
      getFilterDataRecruiters(-1, val, safeValues.cc);
    }

  };

  const onCompanyChange = (val) => {
    setFinalData(prev => ({ ...(prev || {}), jobId: 0, jobStatus: -1, rId: 0, companyCode: String(val) }));
    if (val === "0" || val === 0) {
      getFilterData(-1, -1, -1);
      getFilterDataRecruiters(-1, -1, -1);
    } else {
      getFilterData(-1, -1, val);
      getFilterDataRecruiters(-1, -1, val);
    }

  };

  const styles = useStyles();

  const listStyle = {
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    height: 42,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.04)",

  }

  const rowStyle = {
    margin: "25px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }

  const onRecruiterChange = (val) => setFinalData(prev => ({ ...(prev || {}), rId: toNum(val) }));
  const resetFilters = () => {
    const payload = { ...FILTER_DEFAULTS, jobId: -1 };
    setFinalData(FILTER_DEFAULTS);
    getData(payload);
    getJobs(router.query, payload);
    setIsModalOpen(false);
  };
  return (
    <>
      <Modal
        title="Apply Filters"
        open={isModalOpen}
        onOk={ApplyFilters}
        onCancel={handleCancel}
        centered
        rootClassName="dashboard-filter-modal"
        styles={{
          container: {
            borderRadius: 22,
            overflow: "hidden",
          },
        }}
        footer={[
          <UIButton key="reset-filters" onClick={resetFilters} type="default">
            Reset Filters
          </UIButton>,
          <UIButton key="apply-filters" onClick={ApplyFilters}>
            Apply Filters
          </UIButton>,
        ]}
      >
        {onLoadLoading ?
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <DynamicSkeleton type="squareBox" avatar={false} limit={5} height={30} col={24} />
          </div> :
          <>
            <Row style={rowStyle}>
              <Col md={6}> <UIText>Filter By Company</UIText></Col>
              <Col md={6}><Listbox style={listStyle} key={`company-${safeValues.cc}-${isModalOpen ? 'open' : 'closed'}`} data={companies} defaultValue={safeValues.cc} handleChange={onCompanyChange}/></Col>
            </Row>
            <Row style={rowStyle}>
              <Col md={6}> <UIText>Filter By Job Status</UIText></Col>
              <Col md={6}> <Listbox style={listStyle} key={`status-${safeValues.jst ?? -1}-${isModalOpen ? 'open' : 'closed'}`} data={jobStatus} defaultValue={safeValues.jst} handleChange={onJobStatusChange}/></Col>
            </Row>
            <Row style={rowStyle}>
              <Col md={6}> <UIText>Fillter By Jobs</UIText></Col>
              <Col md={6}> <Listbox style={listStyle} key={`job-${safeValues.js}-${isModalOpen ? 'open' : 'closed'}`} data={jobTitle} defaultValue={safeValues.js} handleChange={onChangeJobs} /></Col>
            </Row>
            <Row style={rowStyle}>
              <Col md={6}> <UIText>Filter By Recruiters</UIText></Col>
              <Col md={6}> <Listbox style={listStyle} key={`recruiter-${safeValues.rt}-${isModalOpen ? 'open' : 'closed'}`} data={recruiters} defaultValue={safeValues.rt} handleChange={onRecruiterChange}  /></Col>
            </Row>
          </>
        }

      </Modal>
    </>
  )
}

export default DashboardFilterModal
const useStyles = createUseStyles({
  "@global": {
    ".ant-select-dropdown": {
      borderRadius: "18px !important",
      overflow: "hidden !important",
      padding: "6px !important",
      border: "1px solid #e5e7eb !important",
      boxShadow: "0 18px 42px rgba(15, 23, 42, 0.12) !important",
    },

    ".ant-select-item": {
      borderRadius: "12px !important",
      marginBottom: "3px !important",
    },
  },
});
